import * as React from "react";
import * as ReactDOM from "react-dom";
import Example from "./example";

ReactDOM.render(<Example />, document.getElementById("root"));
